<div class="full-page-container">
  <div class="d-none d-lg-block">
    <fgb-banner [title]="'account.activity.page.title' | translate"></fgb-banner>
  </div>

  <fgb-page-header [pageTitle]="'account.page.title'" [backButtonLink]="'/'"></fgb-page-header>

  <fgb-account-nav></fgb-account-nav>

  <div class="container">
    <div class="points-history">
      <fgb-transaction-history [transactionTypes]="[transactionTypes.loyalty]" [accountView]="true"></fgb-transaction-history>
    </div>
  </div>
</div>
